import React from "react";
import { CellRenderFunction, CellRenderer } from "@getregistered/greg-editors/";
import { RegistrationCheckPoint } from "./types";
import { CheckinCell } from "./CheckinCell";

export const renderCheckinCell: CellRenderFunction = ({ row, column }) => {
  if (column.type === "checkpoint") {
    const checkPoint = row[column.key] as RegistrationCheckPoint;
    if (checkPoint.attending) {
      return (
        <CheckinCell
          key={[row.id, column.key].join("-")}
          checkPoint={checkPoint}
        />
      );
    } else {
      return <span>NOT ATTENDING</span>;
    }
  }
  return <CellRenderer row={row} column={column} />;
};

export const createRenderCheckinCell = (handleReload: () => void): CellRenderFunction => {
  return ({ row, column }) => {
    if (column.type === "checkpoint") {
      const checkPoint = row[column.key] as RegistrationCheckPoint;
      if (checkPoint.attending) {
        return (
          <CheckinCell
            key={[row.id, column.key].join("-")}
            checkPoint={checkPoint}
            onReload={handleReload}
          />
        );
      } else {
        return <span>"NOT ATTENDING"</span>;
      }
    }
    return <CellRenderer row={row} column={column} />;
  };
};
